module.exports = __webpack_public_path__ + "static/media/emptyCart.35b939b5.svg";